<template>
	<div class="main" v-loading="list_loading">
		<el-table :data="dataList" border style="width: 100%">
			<el-table-column prop="id" label="id"></el-table-column>
			<el-table-column label="发布时间">
				<template scope="scope">
					<span>{{ scope.row.updateTime | formatDate }}</span>
				</template>
			</el-table-column>
			<el-table-column prop="formDesign.title" label="模板名称"></el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button size="mini" type="success" @click="handleDetail(scope.row)" icon="el-icon-view">详情</el-button>
					<el-button size="mini" type="danger" @click="handleDelete(scope.row)" icon="el-icon-delete">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="block">
			<el-pagination
				@current-change="handleCurrentChange"
				:current-page="currentPage"
				background
				@size-change="handleSizeChange"
				:page-sizes="[5, 10, 20]"
				:page-size="pageSize"
				layout="sizes,prev, pager, next,total,jumper"
				:total="total"
			></el-pagination>
		</div>
		<!-- 需要判断当 admin_dv为false时清空formData，否则数据会重复-->
		<el-dialog :title="formTitle" :visible.sync="admin_dv" :before-close="handleClose" width="40%" top="8vh"><form-detail :formData="formData"></form-detail></el-dialog>
	</div>
</template>

<script>
import formDetail from './form_detail.vue';
export default {
	components: {
		formDetail
	},
	data() {
		return {
			total: 0, //总页数
			pageSize: 10, //每页条数
			currentPage: 1,
			dataList: [],
			list_loading: false,
			admin_dv: false,
			formTitle: '',
			formData: [],
			subFormData: {
				formDesign: {
					id: ''
				},
				data: {},
				id: ''
			},
			formDesignId: '',
			detailId: ''
		};
	},
	mounted() {
		window.console.log(this.admin_dv);
	},
	filters: {
		formatDate: function(value) {
			var date = new Date(value); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
			var Y = date.getFullYear() + '-';
			var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
			var D = (date.getDate() + 1 < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
			var h = (date.getHours() + 1 < 10 ? '0' + date.getHours() : date.getHours()) + ':';
			var m = (date.getMinutes() + 1 < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
			var s = (date.getSeconds() + 1 < 10 ? '0' + date.getSeconds() : date.getSeconds()) ;
			// var s = date.getSeconds();
			return Y + M + D + h + m + s;
			
		}
	},
	created() {
		this.getList();
	},
	methods: {
		handleCurrentChange(val) {
			this.currentPage = val; //获取当前页
			this.getList();
		},
		handleSizeChange(psize) {
			//选择每页条数
			this.pageSize = psize;
			this.getList();
		},
		//获取列表
		getList() {
			let data = new FormData();
			data.append('length', this.pageSize);
			data.append('page', this.currentPage);
			// data.append('pageSize', this.pageSize);
			// data.append('pageNum', this.pageNum);
			this.$post('api/form/data/listData', data)
				.then(res => {
					// window.console.log(res);
					this.dataList = res.data.list;
					this.total = res.data.total;
					this.list_loading = false;
				})
				.catch(e => {
					window.console.log(e);
				});
		},
		getFormDetail(id) {
			var that = this;
			// window.console.log(id)
			this.$post('api/form/data/getData?id=' + id).then(res => {
				// window.console.log(res);
				// window.console.log(res.data.data);
				let formData = res.data.data;

				// 把对象转化成数组
				var formArr = [];
				for (let i in formData) {
					formArr.push({
						key: i,
						name: formData[i]
					});
				}
				// window.console.log(formArr);
				// 请求表单数据
				// let data = {
				// 	id: res.data.formDesign.id
				// };
				let data = new FormData();
				data.append('id', res.data.formDesign.id);
				this.$post('api/form/loadFormData', data).then(res => {
					// window.console.log(res);
					var data = res.data.formDesignPageList;
					// window.console.log(data);
					that.formTitle = res.data.title;
					for (var i = 0; i < data.length; i++) {
						that.formDesignId = data[i].formDesignId;
						// window.console.log(that.formDesignId);
						for (var j = 0; j < data[i].formDesignFieldList.length; j++) {
							that.formData.push({
								// formDesignId:data[i].formDesignId,
								formId: data[i].formDesignFieldList[j].id,
								label: data[i].formDesignFieldList[j].label,
								type: data[i].formDesignFieldList[j].type,
								hint: data[i].formDesignFieldList[j].hint, //提示语
								minLength: data[i].formDesignFieldList[j].minLength,
								maxLength: data[i].formDesignFieldList[j].maxLength,
								required: data[i].formDesignFieldList[j].required,
								dropOptions: ['请选择'],
								dropIndex: 0, //下拉列表
								radioItems: [],
								checkItems: [],
								radioIndex: null, //单选框
								checkIndex: [], //多选框
								downImg: [], //图片下载
								downFile: [], //文件下载
								value: ''
							});
						}
					}
					// window.console.log(that.formData);
					// 表单模板回显
					for (var fI = 0; fI < that.formData.length; fI++) {
						for (let i = 0; i < data.length; i++) {
							for (let j = 0; j < data[i].formDesignFieldList.length; j++) {
								for (var a = 0; a < data[i].formDesignFieldList[j].options.length; a++) {
									if (data[i].formDesignFieldList[j].type == 'dropdown' && that.formData[fI].formId == data[i].formDesignFieldList[j].id) {
										that.formData[fI].dropOptions.push(data[i].formDesignFieldList[j].options[a].label);
									} else if (data[i].formDesignFieldList[j].type == 'radiobuttons' && that.formData[fI].formId == data[i].formDesignFieldList[j].id) {
										that.formData[fI].radioItems.push({
											label: data[i].formDesignFieldList[j].options[a].label,
											value: data[i].formDesignFieldList[j].options[a].value
										});
									} else if (data[i].formDesignFieldList[j].type == 'checkboxes' && that.formData[fI].formId == data[i].formDesignFieldList[j].id) {
										// 多选框
										that.formData[fI].checkItems.push({
											label: data[i].formDesignFieldList[j].options[a].label,
											value: data[i].formDesignFieldList[j].options[a].value
										});
									}
								}
							}
						}
					}
					// console.log(that.formData);
					// 内容回显
					for (var af = 0; af < that.formData.length; af++) {
						for (var f = 0; f < formArr.length; f++) {
							if (that.formData[af].formId == formArr[f].key) {
								if (that.formData[af].type == 'dropdown') {
									that.formData[af].dropIndex = formArr[f].name;
								} else if (that.formData[af].type == 'radiobuttons') {
									that.formData[af].radioIndex = formArr[f].name;
									if (that.formData[af].radioIndex != null) {
										// window.console.log(that.formData[af].radioIndex);
										for (var ra = 0; ra < that.formData[af].radioItems.length; ra++) {
											if (that.formData[af].radioItems[ra].value == that.formData[af].radioIndex) {
												// 向一个json格式的某个数据中添加一个属性
												that.formData[af].radioItems[ra].checked = true;
											}
										}
									}
								} else if (that.formData[af].type == 'checkboxes') {
									var checkInList = [];
									var checkString = formArr[f].name;
									checkInList = checkString.split(',');
									// window.console.log(checkInList);
									that.formData[af].checkIndex = checkInList;
									// 多选框回显
									if (that.formData[af].checkIndex.length > 0) {
										for (let ra = 0; ra < that.formData[af].checkItems.length; ra++) {
											for (var ca = 0; ca < that.formData[af].checkIndex.length; ca++) {
												if (that.formData[af].checkItems[ra].value == that.formData[af].checkIndex[ca]) {
													// 向一个json格式的某个数据中添加一个属性
													that.formData[af].checkItems[ra].checked = true;
												}
											}
										}
									}
								} else {
									that.formData[af].value = formArr[f].name;
								}
							}
						}
					}
					// window.console.log(that.formData)
				});
			});
		},
		handleDetail(e) {
			this.admin_dv = true;
			// window.console.log(e);
			this.getFormDetail(e.id);
			this.detailId = e.id;
		},
		// 关闭弹框调用的事件
		handleClose() {
			this.formData = [];
			this.admin_dv = false;
		},
		handleDelete(row) {
			let data = new FormData();
			data.append('id', row.id);
			this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$post('api/form/data/delete', data)
					.then(res => {
						let totalPage = Math.ceil((this.total - 1) / this.pageSize);
						let currentPage = this.currentPage > totalPage ? totalPage : this.currentPage;
						this.currentPage = currentPage < 1 ? 1 : currentPage;
						window.console.log(this.currentPage);

						var isSuccess = res.success;
						if (isSuccess == 1) {
							this.$message({
								type: 'success',
								message: res.message
							});
							this.getList();
						}
					})
					.catch(e => {
						window.console.log(e);
					});
			});
		}
	}
};
</script>

<style scoped="scoped">
.main .block {
	text-align: center;
	margin-top: 20px;
}

.main {
	background: #fff;
	padding: 20px;
}
.add-btn {
	padding-top: 20px;
	margin-bottom: 20px;
}

.add-btn .el-button {
	font-size: 16px;
}
.searchConent {
	padding-top: 20px;
}
.searchConent .el-row .el-col:first-of-type {
	border-right: 1px solid #eee;
}
.searchConent .el-row:first-of-type {
	display: flex;
	border: 1px solid #eee;
}
.searchConent .el-row:nth-of-type(2) {
	border-left: 1px solid #eee;
	border-bottom: 1px solid #eee;
	border-right: 1px solid #eee;
}
.searchConent .el-col:nth-of-type(3) {
	border-left: 1px solid #eee;
	border-right: 1px solid #eee;
}
.searchConent .el-col {
	height: 50px;
	padding: 5px;
	line-height: 38px !important;
	color: #606266;
	font-size: 14px;
}
.searchConent .el-col:first-of-type,
.searchConent .el-col:nth-of-type(3) {
	text-align: center;
}
.searchConent {
	margin-bottom: 20px;
}
.searchConent .search {
	text-align: right;
	margin-top: 20px;
}

/* .el-table td,
	.el-table th {
		text-align: center;
	} */
.searchConent .el-select {
	width: 100%;
}
</style>
